<template>
  <div >
    <container></container>
  </div>
</template>
<script>
import Container from './components/container.vue'
export default {
  components: {
    Container
  }
}
</script>
